/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { View } from '@components/atoms'
import { FullModalLayout, ImageUplodader } from '@components/molecules'

import {
	useAppDispatch,
	useAppSelector,
	routeActions,
	adminUsersActions,
} from '@redux/index'

const UserProfileImageUpdatePage = () => {
	// redux dispatch
	const reduxDispatch = useAppDispatch()
	const selectedUser: { id: string } = useAppSelector(
		state => state.adminUsers.editUserProfileImage,
	)

	const onCloseClick = React.useCallback(() => {
		reduxDispatch(routeActions.NAVIGATE_PATH('/admin/users'))
	}, [])

	const onGetImage = (aFile: File) => {
		reduxDispatch(
			adminUsersActions.UPLDATE_PROFILE_IMAGE({
				userId: selectedUser.id,
				profileImage: aFile,
			}),
		)
	}

	return (
		<View css={style}>
			<FullModalLayout
				title="프로필 이미지 변경"
				onCloseClick={onCloseClick}
				titleStyle={{ marginBottom: '1rem' }}
			>
				<View className="userProfileImageOuterView">
					<ImageUplodader onGetImage={onGetImage} />
				</View>
			</FullModalLayout>
		</View>
	)
}

export default UserProfileImageUpdatePage

const style = css({
	'.userProfileImageOuterView': {
		position: 'relative',
		height: 'fit-contents',
		overflow: 'auto',
		textAlign: 'left',

		'.textFieldView': {
			marginBottom: '1rem',
		},

		'.bottomView': {
			display: 'flex',
			justifyContent: 'right',
			alignItems: 'center',
			height: '4rem',
			width: '100%',
			marginTop: '3rem',
		},
	},
})
